module.exports = __webpack_public_path__ + "static/media/krogeriet.856e311c.png";